var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":_vm.onlyCache,"exclude":_vm.doNotCache}},[_c('router-view',{attrs:{"eventBus":_vm.eventBus},on:{"toggle-side-bar":_vm.toggleSideBar}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }